import { render, staticRenderFns } from "./add_publicity.vue?vue&type=template&id=1be3461c&scoped=true&"
import script from "./add_publicity.vue?vue&type=script&lang=js&"
export * from "./add_publicity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3461c",
  null
  
)

export default component.exports